import React from 'react';
import { Table } from 'reactstrap';

const RoleWeightingTable = ({ roleWeightings = [], totalWeighting }) => {
  const defaultWeightings = [
    {
      peran: 'Atasan',
      bobot: '75%',
      nilaiRataRata: '-',
      nilaiAkhirSetelahBobot: '0.00'
    },
    {
      peran: 'Rekan / Sejawat',
      bobot: '25%',
      nilaiRataRata: '89.60',
      nilaiAkhirSetelahBobot: '22.40'
    },
    {
      peran: 'Bawahan',
      bobot: '0%',
      nilaiRataRata: '-',
      nilaiAkhirSetelahBobot: '-'
    }
  ];

  const defaultTotal = {
    peran: 'Total / Nilai Akhir',
    bobot: '100%',
    nilaiRataRata: '-',
    nilaiAkhirSetelahBobot: '22.40',
    predikat: 'Sangat Kurang',
    predikatId: 'sangat-kurang'
  };

  const rows = roleWeightings.length > 0 ? roleWeightings : defaultWeightings;
  const total = totalWeighting || defaultTotal;

  return (
    <div className="p360-weighting-container">
      {/* Title */}
      <div className="p360-weighting-title">
        {/* <i className="uil uil-calculator text-primary" style={{ fontSize: '1.2rem' }}></i> */}
        <span>Pembobotan Peran (Nilai Akhir Keseluruhan / Overall)</span>
      </div>

      {/* Table */}
      <div className="table-responsive rounded-3 overflow-hidden">
        <Table className="p360-table p360-weighting-table mb-0 align-middle">
          <thead>
            <tr>
              <th style={{ minWidth: '180px' }}>Peran</th>
              <th className="text-center" style={{ minWidth: '120px' }}>Bobot (%)</th>
              <th className="text-center" style={{ minWidth: '200px' }}>Nilai (Rata-Rata Kelompok)</th>
              <th className="text-center" style={{ minWidth: '200px' }}>Nilai Akhir (Setelah Bobot)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                <td style={{ fontWeight: 600, color: '#334155' }}>
                  {row.peran}
                </td>
                <td className="text-center" style={{ fontWeight: 600 }}>
                  {row.bobot}
                </td>
                <td className="text-center" style={{ fontWeight: 500 }}>
                  {row.nilaiRataRata}
                </td>
                <td className="text-center" style={{ fontWeight: 600 }}>
                  {row.nilaiAkhirSetelahBobot}
                </td>
              </tr>
            ))}

            {/* Total Row */}
            {total && (
              <tr className="total-row">
                <td>
                  <strong>{total.peran}</strong>
                </td>
                <td className="text-center">
                  <strong>{total.bobot}</strong>
                </td>
                <td className="text-center">
                  {total.nilaiRataRata}
                </td>
                <td className="text-center">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <strong style={{ fontSize: '1rem' }}>{total.nilaiAkhirSetelahBobot}</strong>
                    {total.predikat && (
                      <span className={`p360-badge ${total.predikatId || 'sangat-kurang'}`}>
                        {total.predikat}
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default RoleWeightingTable;
